var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E9F7F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1664 11.2662L19.2414 8.90791C22.4164 7.84958 24.1414 9.58291 23.0914 12.7579L20.7331 19.8329C19.1497 24.5912 16.5497 24.5912 14.9664 19.8329L14.2664 17.7329L12.1664 17.0329C7.40807 15.4496 7.40807 12.8579 12.1664 11.2662Z",
    stroke: "#22AD80",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4238 17.3753L17.4072 14.3837",
    stroke: "#22AD80",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceive);
export default __webpack_public_path__ + "static/media/receive.79b6ccfd916bf455e75584581ffbe159.svg";
export { ForwardRef as ReactComponent };